import React, { useContext } from 'react';
import { ApLoaderDefault, ApLoaderText } from '@alixpartners/ui-components';
import HighchartsReact from 'highcharts-react-official';
import {
	Breadcrumbs,
	Header,
	LoadingContainer,
	NoData,
	SectionWrapper,
	Title,
} from './ChartList.styles';
import Highcharts from 'highcharts';
import { ChartWrapper } from 'Investigate/WaterfallChart/WaterfallChart.styles';
// import Tooltip from './Tooltip';
// import { renderToString } from 'react-dom/server';
import { formatSpendWithDecimalAndSymbol } from 'utils/number';
import { SettingsContext } from 'contexts/SettingsContext';

const VendorCountByCategory = ({
	chartTitle,
	chartheight,
	isLoading,
	chartData,
	handleColumnClick,
	yAxis,
	categoryAndLevel,
	onTopVendorsClick,
}) => {
	const { hideDecimals } = useContext(SettingsContext);
	const chartRef = React.useRef(null);

	// const color = [
	// 	'#032E45',
	// 	'#012935',
	// 	'#00212E',
	// 	'#001A27',
	// 	'#00131F',
	// 	'#000C18',
	// 	'#000511',
	// 	'#00020A',
	// 	'#000003',
	// 	'#000000',
	// ];

	const options = {
		chart: {
			type: 'treemap',
			height: chartheight,
			spacingTop: 0,
			style: { fontFamily: 'Roboto' },
		},
		colorAxis: {
			minColor: '#FFFFFF',
			maxColor: '#032E45',
		},
		exporting: { enabled: false, allowHTML: true },
		credits: { enabled: false },
		title: { text: '' },
		boost: {
			useGPUTranslations: true,
		},

		legend: {
			enabled: false,
		},
		tooltip: {
			enabled: true,

			formatter:
				yAxis === 'Spend'
					? function() {
							return `<b>${
								this.point.name
							}</b><br/> Total Spend : ${formatSpendWithDecimalAndSymbol(
								this.point.value,
								'$',
								hideDecimals,
								2
							).toUpperCase()}`;
					  }
					: function() {
							return `<b>${this.point.name}</b><br/> Vendor Count : ${
								this.point.value
							}`;
					  },
		},
		// tooltip: {
		// 	shared: true,
		// 	useHTML: true,
		// 	backgroundColor: 'rgba(255,255,255, 0.9)',
		// 	borderWidth: 0,
		// 	borderRadius: 2,
		// 	outside: true,
		// 	formatter: function() {
		// 		const { point } = this;
		// 		console.log(point)
		// 		return renderToString(
		// 			<Tooltip
		// 				tooltipData={point?.tooltip}
		// 				color={point?.color}
		// 			/>
		// 		);
		// 	},
		// },
		plotOptions: {
			series: {
				animation: false,
				shadow: false,

				point: {
					events: {
						click: function(obj) {
							if (categoryAndLevel.level !== 4) {
								handleColumnClick(obj.point.name, 'drilldown');
							} else if (yAxis === 'Spend') {
								onTopVendorsClick(obj.point.name);
							}
						},
					},
				},
			},
		},
		series: [
			{
				// layoutAlgorithm: 'squarified',
				data: chartData,
			},
		],
	};

	return (
		<SectionWrapper>
			<Header>
				<Title>{chartTitle}</Title>
			</Header>

			{isLoading ? (
				<LoadingContainer>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoadingContainer>
			) : (
				<>
					{chartData.length === 0 ? (
						<NoData>No data available</NoData>
					) : (
						<>
							{
								<Breadcrumbs>
									{categoryAndLevel.breadcrumbs.map((crumb, index) => (
										<>
											{index < 4 && index > 0 && '\u00A0/\u00A0'}
											<span
												onClick={() =>
													handleColumnClick([crumb, index + 1], 'drillup')
												}
											>
												{crumb}
											</span>
										</>
									))}
								</Breadcrumbs>
							}

							<ChartWrapper>
								<HighchartsReact
									highcharts={Highcharts}
									options={{
										...options,
									}}
									ref={chartRef}
								/>
							</ChartWrapper>
						</>
					)}
				</>
			)}
		</SectionWrapper>
	);
};

export default React.memo(VendorCountByCategory);
